import React, { useState, useEffect, useRef } from 'react';
import './TempInputWithArrows.css';

const config = require('../config');

const TempInputWithArrowsThermiaHeatPump = ({ header, inputValue }) => {
  const [value, setValue] = useState(inputValue);
  const token = localStorage.getItem('token');
  const timerRef = useRef(null);

  useEffect(() => {
    setValue(inputValue);
  }, [inputValue]);

  const handleIncrease = () => {
    let newValue = value + 1;
    debouncePostValue(newValue);
    setValue(newValue);
  };

  const handleDecrease = () => {
    if (value > 0) {
      let newValue = value - 1;
      debouncePostValue(newValue);
      setValue(newValue);      
    }
  };

  const debouncePostValue = (value) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => postValue(value), 1000); // 1000ms delay
  }

  const postValue = (value) => { 
    if (value >= 5 && value <= 30) {
      fetch(config.serverUrl + '/smedsby-thermia-heat-pump-target', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          value: value
        })
      })
      .catch(error => { console.log(error); });
    }
  }
  return (
    <div className="input-container">
      <span className="header">{header}</span>
      <input type="text" value={value ?? ''} readOnly className='input-field' />
      <div className="button-container">
        <button onClick={handleIncrease} className="arrow-button">&#9650;</button>
        <button onClick={handleDecrease} className="arrow-button">&#9660;</button>
      </div>
    </div>
  );
};

export default TempInputWithArrowsThermiaHeatPump;